// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-insight-description-view{display:block;padding:15px 20px;line-height:2.1rem;word-break:break-all}.ac-insight-description-view--empty{color:#a9a9a9}\n", ""]);
// Exports
module.exports = exports;
